import React, { forwardRef } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { applyClasses, applyProps } from '../shared/js';

import styles from './nav.module.scss';

const Subnav = forwardRef(({ links, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(styles.subnav, applyClasses(props, styles))}
    {...applyProps(props)}
  >
    {links.map((link, index) => (
      <SubnavLink key={index} url={link.url} label={link.label} />
    ))}
    {children}
  </div>
));

const SubnavLink = ({ url, label }) => {
  return (
    <a href={url} className={cn(styles.subnavLink)}>
      {label}
    </a>
  );
};

Subnav.propTypes = {
  /** The links to add to the subnav */
  links: PropTypes.array,
  /** Other content to appear after the links */
  children: PropTypes.any,
};

Subnav.defaultProps = {
  links: [],
  children: undefined,
};

Subnav.displayName = 'Subnav';

SubnavLink.propTypes = {
  /** The URL of the page the button should link to */
  url: PropTypes.string,
  /** The text content of the link */
  label: PropTypes.any,
};

SubnavLink.defaultProps = {
  url: undefined,
  label: undefined,
};

export default Subnav;
